import React, { Component } from 'react';

import "./Header.scss"

class Header extends Component {
  constructor() {
    super();
    this.state = {
    }
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="middlelogo">
              <div className="logo"></div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js